import { Env } from '@protector/utils';

export const {
  AUTH_SECRET_ID,
  BALANCE_URL,
  CORE_SERVICES_API_URL,
  NEMADIGITAL_URL,
  OAUTH_CROPWISE_URL,
  PROTECTOR_API_URL,
  PROTECTOR_CROPWISE_API_URL,
  API_REMOTE_SENSING_URL,
  API_POWER_BI_URL
} = Env;

export const NEMADIGITAL_CUP_API_URL = `${CORE_SERVICES_API_URL ?? ''}/api/cropwise/nemadigital/v1`;
